import {
  MARKETING_CONSENT_ITEM_KEY,
  MARKETING_CONSENT_TEXT_VERSION,
  type MarketingConsentData,
} from '../../types/marketing-consent';

function itemApiPath(): string {
  return `/api/user-state/${encodeURIComponent(MARKETING_CONSENT_ITEM_KEY)}`;
}

/**
 * Writes the marketing-email opt-in as its own user-state item, kept separate from any
 * job-alert consent record (unbundled consent). Retries once on a version conflict (409),
 * mirroring the saved-search write-through pattern in useSavedSearchAccountSync.
 */
export async function writeMarketingConsent(optedIn: boolean, consentSource: string): Promise<boolean> {
  const buildData = (): MarketingConsentData => ({
    optedIn,
    consentAt: Date.now(),
    consentTextVersion: MARKETING_CONSENT_TEXT_VERSION,
    consentSource,
  });

  try {
    let response = await fetch(itemApiPath(), {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ data: buildData(), version: 0 }),
    });
    if (response.status === 409) {
      const latest = await response.json();
      response = await fetch(itemApiPath(), {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ data: buildData(), version: latest.version }),
      });
    }
    return response.ok;
  } catch {
    return false;
  }
}
